<template>
  <div :class="`message ${theme.isDark ? 'message_dark' : null}`">
    <div class="message__info">
      <p class="message__author">{{ author }}</p>
      <p class="message__date">
        <span>{{ date }} </span>
        <span>{{ time }}</span>
      </p>
    </div>
    <p class="text-subtitle-1 message__text">
      {{ text }}
    </p>
  </div>
</template>

<script>
import SortService from "@/services/sort.service";

export default {
  name: "Email",
  inject: ["theme"],
  props: {
    author: String,
    created: String,
    text: String,
  },
  data() {
    return {
      date: SortService.sortDate(this.created)[0],
      time: SortService.sortDate(this.created)[1],
    };
  },
};
</script>
